import React from "react";

export function Section({ title, right, children, className = "" }) {
  return (
    <section className={`panel p-5 ${className}`}>
      {(title || right) && (
        <div className="flex items-center justify-between mb-4">
          {title && (
            <h2 className="font-display text-[13px] tracking-[0.28em] text-[var(--kk-gold-soft)] uppercase">
              {title}
            </h2>
          )}
          {right}
        </div>
      )}
      {children}
    </section>
  );
}

export function KV({ label, value, mono = true, testid }) {
  return (
    <div className="flex items-start justify-between gap-3 py-1.5 border-b border-dashed border-[var(--kk-line)] last:border-b-0">
      <span className="text-[10.5px] uppercase tracking-[0.18em] text-[var(--kk-muted)] mt-0.5">
        {label}
      </span>
      <span
        data-testid={testid}
        className={`${mono ? "font-mono" : ""} text-[12px] text-[var(--kk-ivory)] text-right break-all max-w-[60%]`}
      >
        {value ?? "—"}
      </span>
    </div>
  );
}

export function Tag({ children, tone = "muted" }) {
  const colors = {
    muted: "text-[var(--kk-muted)] border-[var(--kk-line)] bg-[var(--kk-graphite-2)]",
    gold: "text-[var(--kk-gold-soft)] border-[rgba(212,175,55,0.45)] bg-[rgba(212,175,55,0.06)]",
    win: "text-[#aee0a8] border-[#3e6b3a] bg-[rgba(111,174,106,0.08)]",
    loss: "text-[#e2a09d] border-[#6b3a37] bg-[rgba(194,84,80,0.08)]",
  };
  return (
    <span
      className={`chip ${colors[tone]} uppercase`}
      style={{ letterSpacing: "0.12em" }}
    >
      {children}
    </span>
  );
}
